module.exports = __webpack_public_path__ + "static/media/location.75c26dd4.svg";